import { render, staticRenderFns } from "./PrintSingleComment.vue?vue&type=template&id=6362c3e3&"
import script from "./PrintSingleComment.vue?vue&type=script&lang=js&"
export * from "./PrintSingleComment.vue?vue&type=script&lang=js&"
import style0 from "./PrintSingleComment.vue?vue&type=style&index=0&id=6362c3e3&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PrintSingleComment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6362c3e3')) {
      api.createRecord('6362c3e3', component.options)
    } else {
      api.reload('6362c3e3', component.options)
    }
    module.hot.accept("./PrintSingleComment.vue?vue&type=template&id=6362c3e3&", function () {
      api.rerender('6362c3e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print/report/PrintSingleComment.vue"
export default component.exports